export const ACTION_TYPE = {
    GET_USER_DATA: 'get_user_data',
    GET_NURSING_MANAGEMENT_COUNT_PROVIDER: 'get_nursing_management_count_provider',
    GET_PROVIDER_COUNT: 'get_provider_count',
    UPDATE_DOCTOR_STATUS: 'update_doctor_status',
    UPDATE_CORPORATE_ORGANISATION: 'update_corporate_organisation',
    UPDATE_NOTIFICATION: 'update_notification'
}